// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"Navigator_navWrapper__oLVxR","navColumnWrapper":"Navigator_navColumnWrapper__1A4p8"};